var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "reservation-programs" }, [
    _c(
      "div",
      { staticClass: "route-page-content breadcrumb-content" },
      [
        _c("SidebarChild", {
          attrs: {
            items: _vm.menuItems,
            "selected-item": _vm.currentPage,
            focusActive: true,
          },
          on: { selected: _vm.fnClicked, clicked: _vm.fnClicked },
        }),
        _vm._v(" "),
        _c("div", { staticClass: "page-content-wrapper" }, [
          _c(
            "div",
            { staticClass: "header-container" },
            [
              _c("h2", [
                _vm._v(_vm._s(_vm.$t("calendar.reservationPrograms"))),
              ]),
              _vm._v(" "),
              _c(
                "SupsisButton",
                { attrs: { primary: "" }, on: { click: _vm.addNewProgram } },
                [_vm._v(_vm._s(_vm.$t("calendar.addReservationProgram")))]
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "programs-groups" },
            _vm._l(_vm.groupedPlans, function (group, userId) {
              return _c(
                "div",
                { key: userId, staticClass: "group-container" },
                [
                  _c(
                    "div",
                    {
                      staticClass: "group-header",
                      on: {
                        click: function ($event) {
                          return _vm.toggleGroup(userId)
                        },
                      },
                    },
                    [
                      _c("AgentAvatar", {
                        attrs: { userID: userId, size: 32 },
                      }),
                      _vm._v(" "),
                      _c("span", [_vm._v(_vm._s(_vm.getGroupName(userId)))]),
                      _vm._v(" "),
                      _c("a-icon", {
                        staticClass: "toggle-icon",
                        attrs: { type: _vm.openGroups[userId] ? "up" : "down" },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.openGroups[userId],
                          expression: "openGroups[userId]",
                        },
                      ],
                      staticClass: "programs-grid",
                    },
                    _vm._l(group, function (plan) {
                      return _c(
                        "div",
                        {
                          key: plan._id,
                          staticClass: "program-card",
                          on: {
                            click: function ($event) {
                              return _vm.goToPlanDetails(plan)
                            },
                          },
                        },
                        [
                          _c("h3", [_vm._v(_vm._s(plan.title))]),
                          _vm._v(" "),
                          _c(
                            "p",
                            { staticClass: "d-flex align-center gap-5" },
                            [
                              _c("i", { staticClass: "material-icons" }, [
                                _vm._v("timer"),
                              ]),
                              _vm._v(
                                "\n                                " +
                                  _vm._s(_vm.$t("report.duration")) +
                                  ": " +
                                  _vm._s(plan.duration) +
                                  " " +
                                  _vm._s(_vm.$t("report.minute")) +
                                  "\n                            "
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "card-actions" },
                            [
                              _c(
                                "SupsisButton",
                                {
                                  on: {
                                    click: function ($event) {
                                      $event.stopPropagation()
                                      return _vm.viewPlan(plan)
                                    },
                                  },
                                },
                                [_vm._v(_vm._s(_vm.$t("calendar.buttonOpen")))]
                              ),
                              _vm._v(" "),
                              _vm.canEditPlan(plan)
                                ? [
                                    _c(
                                      "SupsisButton",
                                      {
                                        attrs: { primary: "" },
                                        on: {
                                          click: function ($event) {
                                            $event.stopPropagation()
                                            return _vm.editPlan(plan)
                                          },
                                        },
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(_vm.$t("message.edit")) +
                                            "\n                                    "
                                        ),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "SupsisButton",
                                      {
                                        attrs: { danger: "" },
                                        on: {
                                          click: function ($event) {
                                            $event.stopPropagation()
                                            return _vm.confirmDeletePlan(plan)
                                          },
                                        },
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(_vm.$t("message.delete")) +
                                            "\n                                    "
                                        ),
                                      ]
                                    ),
                                  ]
                                : _vm._e(),
                            ],
                            2
                          ),
                        ]
                      )
                    }),
                    0
                  ),
                ]
              )
            }),
            0
          ),
        ]),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }